import { Chip, type SvgComponentType } from "@newsela/angelou";
import { objectTypes } from "@newsela/snitch";

import { IContentValues } from "@/search/Langston/types/IContentValues";
import { LangstonParameterSchema } from "../../LangstonParameterSchema";
import { getContentTypeChipCss } from "./ContentTypeFilterChips.styles";

const WORKSHEET_ENUM = "WORKSHEET";

interface IContentTypeFilterChips {
  activeChips: string[];
  contentTypeValues: IContentValues[];
  isWorthsheetsEnabled: boolean;
  hideAllChip?: boolean;
}

export const ContentTypeFilterChips = ({
  activeChips,
  contentTypeValues,
  isWorthsheetsEnabled,
  hideAllChip = false,
}: IContentTypeFilterChips) => {
  const isSelectAllChipActive =
    activeChips.length === 0 && !isWorthsheetsEnabled;

  return (
    <>
      {!hideAllChip && (
        <Chip
          __cssFor={getContentTypeChipCss(isSelectAllChipActive, true)}
          key="select-all-chip"
          dataProps={{
            "data-qa-selector": "select-all-content-types-filter",
            "data-testid": "select-all-content-types-filter",
            "data-tracker-model": objectTypes.content,
          }}
          active={isSelectAllChipActive}
          text="All"
          value="all"
        />
      )}
      {contentTypeValues.map((contentType, index) => {
        const isContentTypeChipActive =
          activeChips.some((chip) => {
            const values = contentType.value.split("&");
            return values.includes(chip);
          }) ||
          (contentType.value === WORKSHEET_ENUM && isWorthsheetsEnabled);
        const svg = LangstonParameterSchema.content_types.values.find(
          (value) => value.value === contentType.value,
        )?.SvgComponent;

        return (
          <Chip
            __cssFor={getContentTypeChipCss(isContentTypeChipActive)}
            key={index}
            dataProps={{
              "data-qa-selector": `select-${contentType.value}-search-filter`,
              "data-testid": `select-${contentType.value}-search-filter`,
              "data-tracker-model": objectTypes.content,
            }}
            active={isContentTypeChipActive}
            text={contentType.label}
            SvgComponent={svg as SvgComponentType}
            value={contentType.value}
          />
        );
      })}
    </>
  );
};
